<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-alert message="当前解析地址：http://www.xxxx.com/xxxx.aspx?id=1&code=MA.156.110108.52/91.12000000.1/xxxx" type="warning" :banner="true"/>
      <a-card class="card">
        <a-form class="form" :form="form">
          <a-form-item label="解析地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input placeholder="请输入解析地址" v-model="resolveAddress" v-decorator.trim="['resolveAddress', validatorRules.resolveAddress]"/>
          </a-form-item>
          <a-form-item label="测试地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input placeholder="请输入测试地址" v-model="testAddress" v-decorator.trim="['testAddress', validatorRules.testAddress]"/>
          </a-form-item>
          <a-form-item label="解析模板" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input placeholder="请输入解析模板" v-model="resolveTemplate" v-decorator.trim="['resolveTemplate', validatorRules.resolveTemplate]"/>
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" class="but">
            <a-button type="primary" class="save" @click="saveSet">保存设置</a-button>
            <a-button @click="cancel">取消</a-button>
          </a-form-item>
        </a-form>
      </a-card>
    </a-col>
  </a-row>
</template>

<script>
  export default {
    data() {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 8 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 8 }
        },

        form: this.$form.createForm(this, { name: 'dynamic_rule' }),
        // 数据
        resolveAddress: '',
        testAddress: '',
        resolveTemplate: '',

        validatorRules: {
          resolveAddress: {
            rules: [
              {
                required: true,
                message: '请输入解析地址!',
              }
            ]
          },
          testAddress: {
            rules: [
              {
                required: true,
                message: '请输入测试地址!',
              }
            ]
          },
          resolveTemplate: {
            rules: [
              {
                required: true,
                message: '请输入解析模板!',
              }
            ]
          }
        }
      }
    },
    methods: {
      // 保存设置 - 点击事件
      saveSet() {
        this.form.validateFields(err => {
          if (!err) {
            console.info('success');
          }
        })
      },
      // 取消 - 点击事件
      cancel() {
        this.form.resetFields()
      }
    }
  }
</script>

<style scoped>
  .card {
    height: 81vh;
  }
  .form {
    margin-top: 8%
  }
  .but {
    display: flex;
    justify-content: flex-end;
  }
  .save {
    margin-right: 10px;
  }
</style>